<template>
  <div>
    <!-- Form -->
    <!-- Confirmation delete box -->
    <v-layout row justify-center>
      <v-dialog v-model="dialog2" max-width="290">
        <v-card>
          <v-card-text>Are you sure you want to save this data?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat="flat" @click.native="dialog2 = false">Disagree</v-btn>
            <v-btn
              color="green darken-1"
              flat="flat"
              @click.native="validateBeforeSubmit()"
            >Agree</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- /Confirmation delete box -->

    <v-card>

      <!-- Confirmation box -->
      <v-layout row justify-center>
        <v-dialog v-model="confirmDialog" max-width="500">
          <v-card>
            <v-card-title>
              <span class="headline">Partial Payment</span>
            </v-card-title>
            
            <hr />
            <v-card-text v-if="partialPayDataset.length > 0">


              <table>
                <tr>
                  <td colspan="1">Last Closing Balance </td>
                  <td colspan="1">&nbsp; : &nbsp;</td>
                  <td colspan="4">{{ partialPayDataset[0].closing_principal | currency }}</td>
                </tr>

                <tr v-for="(item,key) in partialPayDataset" :key="key">
                  <td>Receive Date</td>
                  <td>&nbsp; : &nbsp;</td>
                  <td>{{ changeFormateDMY(item.partial_date) }}</td>
                  <td>&nbsp; : &nbsp;</td>
                  <td>Partial Payment</td>
                  <td>&nbsp; : &nbsp;</td>
                  <td>{{ item.partial_amount }}</td>
                </tr>

                <tr>
                  <td>Closing Balance</td>
                  <td>&nbsp; : &nbsp;</td>
                  <td>{{ partialPayDataset[0].new_closing_balance | currency }}</td>
                </tr>

              </table>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="success" @click.native="goToShedule">
                OK
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
      <!-- /Confirmation box -->

      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>
      <v-form v-model="valid" ref="form" lazy-validation>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap> 
                <v-flex xs12 sm6 md4 >
                <v-autocomplete
                  label="Loan Number *"
                  item-text="loan_no"
                  item-value="id"
                  v-model="formSchema.loan_id"
                  :items="loanNoList"
                  :rules="[v => !!v || 'Loan number is required !']"
                  required
                  @change="getClientName(formSchema.loan_id)"
                ></v-autocomplete>
              </v-flex>

              <v-flex xs12 sm6 md4>
                <v-text-field
                  label="Currency *"
                  v-model="formSchema.currency" 
                  :rules="[v => !!v || 'Field is required !']"
                  required>	
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field
                  label="USD Rate *"
                  v-model="formSchema.usd_rate" 
                  :rules="[v => !!v || 'Field is required !', lng200,decimal]"
                  @input="changeDataSet"
                  required>	
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field
                  label="Principal Amont *"
                  v-model="formSchema.principal" 
                  :rules="[v => lng200,decimal]"
                  @input="changeDataSet"
                >	
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field
                  label="Interest Amount *"
                  v-model="formSchema.interest" 
                  :rules="[v => lng200,decimal]"
                  @input="changeDataSet"
                >	
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field
                  label="Charge Amount *"
                  v-model="formSchema.charge" 
                  :rules="[v => lng200,decimal]"
                  @input="changeDataSet"
                >	
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field
                  label="Total Amount *"
                  v-model="formSchema.amount" 
                  :rules="[v => !!v || 'Field is required !', lng200,decimal]"
                  readonly
                  required>	
                ></v-text-field>
              </v-flex>

                <v-flex xs12 sm6 md4 class="pr-4">
                    <DatePicker
                      :key="formSchema.id"
                      :inputData="{index:1,fieldName:'receive_date', fieldValue:formSchema.receive_date, label:'Receive Date *', required:1}"
                      @setValue="setDateValue"
                    ></DatePicker>
                  </v-flex>

                  <v-flex xs12 sm6 md4 class="pr-4">
                    <v-text-field
                      label="Cheque No"
                      v-model="formSchema.cheque_no"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md4 class="pr-4">
                    <DatePicker
                      :key="formSchema.id"
                      :inputData="{index:1,fieldName:'cheque_date', fieldValue:formSchema.cheque_date, label:'Cheque Date'}"
                      @setValue="setDateValue"
                    ></DatePicker>
                  </v-flex>

                  <v-flex xs12 sm6 md4 class="pr-4">
                    <v-text-field
                      label="Remark"
                      v-model="formSchema.remark"
                    ></v-text-field>
                  </v-flex>
                            
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" @click.native="saveItem" :disabled="!valid">
            <v-icon>save</v-icon>
            {{addUpdateBtn}}
          </v-btn>
          <v-btn color="error" @click.native="reset">
            <v-icon>refresh</v-icon>Reset
          </v-btn>
        </v-card-actions>
      </v-form>

      <hr />
          <table class="paySchedule" v-show="showVoucher">
            <tbody>
              <tr class="tb-td">
                <th style="width: 25%;">Account Name</th>
                <th>TR Debit</th>
                <th>TR Credit</th>
                <th>Currency</th>
                <th>BDT Debit</th>
                <th>BDT Credit</th>
                <th>USD Debit</th>
                <th>USD Credit</th>
                <!-- <th>Src Fund</th> -->
              </tr>
              <!-- __________________ Debit Row _________________ -->
              <tr>
                <td class="textCenter">
                  <input type="text" v-model="debit.account_name" readonly />
                </td>
                <td class="textCenter">
                  <input type="text" v-model="debit.tr_debit" readonly />
                </td>
                <td class="textCenter">
                  <input type="text" v-model="debit.tr_credit" readonly />
                </td>
                <td class="textCenter">
                  <input type="text" v-model="debit.currency" readonly />
                </td>
                <td class="textCenter">
                  <input type="text" v-model="debit.bdt_debit" readonly />
                </td>
                <td class="textCenter">
                  <input type="text" v-model="debit.bdt_credit" readonly />
                </td>
                <td class="textCenter">
                  <input type="text" v-model="debit.usd_debit" readonly />
                </td>
                <td class="textCenter">
                  <input type="text" v-model="debit.usd_credit" readonly />
                </td>
                <!-- <td class="textCenter">
                  <input type="text" v-model="debit.src_fund" readonly />
                </td> -->
              </tr>
              <!-- __________________ /Debit Row _________________ -->
              <!-- __________________ Principal Row _________________ -->
              <tr>
                <td class="textCenter">
                  <input type="text" v-model="principal.account_name" readonly />
                </td>
                <td class="textCenter">
                  <input type="text" v-model="principal.tr_debit" readonly />
                </td>
                <td class="textCenter">
                  <input type="text" v-model="principal.tr_credit" readonly />
                </td>
                <td class="textCenter">
                  <input type="text" v-model="principal.currency" readonly />
                </td>
                <td class="textCenter">
                  <input type="text" v-model="principal.bdt_debit" readonly />
                </td>
                <td class="textCenter">
                  <input type="text" v-model="principal.bdt_credit" readonly />
                </td>
                <td class="textCenter">
                  <input type="text" v-model="principal.usd_debit" readonly />
                </td>
                <td class="textCenter">
                  <input type="text" v-model="principal.usd_credit" readonly />
                </td>
                <!-- <td class="textCenter">
                  <input type="text" v-model="principal.src_fund" readonly />
                </td> -->
              </tr>
              <!-- __________________ /Debit Row _________________ -->

              <!-- __________________ Interest Row _________________ -->
              <tr>
                
                <td class="textCenter">
                  <input type="text" v-model="interest.account_name" readonly />
                </td>
                <td class="textCenter">
                  <input type="text" v-model="interest.tr_debit" readonly />
                </td>
                <td class="textCenter">
                  <input type="text" v-model="interest.tr_credit" readonly />
                </td>
                <td class="textCenter">
                  <input type="text" v-model="interest.currency" readonly />
                </td>
                <td class="textCenter">
                  <input type="text" v-model="interest.bdt_debit" readonly />
                </td>
                <td class="textCenter">
                  <input type="text" v-model="interest.bdt_credit" readonly />
                </td>
                <td class="textCenter">
                  <input type="text" v-model="interest.usd_debit" readonly />
                </td>
                <td class="textCenter">
                  <input type="text" v-model="interest.usd_credit" readonly />
                </td>
                <!-- <td class="textCenter">
                  <input type="text" v-model="interest.src_fund" readonly />
                </td> -->
              </tr>
              <!-- __________________ /Debit Row _________________ -->
              <!-- __________________ charge Row _________________ -->
              <tr>
                
                <td class="textCenter">
                  <input type="text" v-model="charge.account_name" readonly />
                </td>
                <td class="textCenter">
                  <input type="text" v-model="charge.tr_debit" readonly />
                </td>
                <td class="textCenter">
                  <input type="text" v-model="charge.tr_credit" readonly />
                </td>
                <td class="textCenter">
                  <input type="text" v-model="charge.currency" readonly />
                </td>
                <td class="textCenter">
                  <input type="text" v-model="charge.bdt_debit" readonly />
                </td>
                <td class="textCenter">
                  <input type="text" v-model="charge.bdt_credit" readonly />
                </td>
                <td class="textCenter">
                  <input type="text" v-model="charge.usd_debit" readonly />
                </td>
                <td class="textCenter">
                  <input type="text" v-model="charge.usd_credit" readonly />
                </td>
                <!-- <td class="textCenter">
                  <input type="text" v-model="charge.src_fund" readonly />
                </td> -->
              </tr>
              <!-- __________________ /Debit Row _________________ -->

            </tbody>
          </table>

    </v-card>
    <!-- /Form -->
  </div>
</template>


<script>
let commonService = require("../../../services/common.service"); 
import DatePicker from "../../global/date_picker";

export default {
  components: {
    DatePicker
  },
  props: ["formSchema"], 
  
  data: () => ({
    valid: true,
    isActiveVal: 1, 
    loanNoList:[],
    partialPayDataset:[],
    confirmDialog: false, 
    showVoucher:false, 
    dialog2:false,
    debit: {
      eco_id:"",
      eco_code: "",
      account_name: "",
      tr_debit: "",
      tr_credit: "",
      currency: "",
      bdt_debit: "",
      bdt_credit: "",
      usd_debit: "",
      usd_credit: "",
      src_fund: "",
      loan_no: "",
      amount_type: "De"
    },
    principal: {
      eco_id:"",
      eco_code: "",
      account_name: "",
      tr_debit: "",
      tr_credit: "",
      currency: "",
      bdt_debit: "",
      bdt_credit: "",
      usd_debit: "",
      usd_credit: "",
      src_fund: "",
      loan_no: "",
      amount_type: "P"
    },
    interest: {
      eco_id:"",
      eco_code: "",
      account_name: "",
      tr_debit: "",
      tr_credit: "",
      currency: "",
      bdt_debit: "",
      bdt_credit: "",
      usd_debit: "",
      usd_credit: "",
      src_fund: "",
      loan_no: "",
      amount_type: "I"
    },
    charge: {
      eco_id:"",
      eco_code: "",
      account_name: "",
      tr_debit: "",
      tr_credit: "",
      currency: "",
      bdt_debit: "",
      bdt_credit: "",
      usd_debit: "",
      usd_credit: "",
      src_fund: "",
      loan_no: "",
      amount_type: "C"
    },
    credit: {
      eco_id:"",
      eco_code: "",
      account_name: "",
      tr_debit: "",
      tr_credit: "",
      currency: "",
      bdt_debit: "",
      bdt_credit: "",
      usd_debit: "",
      usd_credit: "",
      src_fund: "",
      loan_no: "",
      amount_type: "P"
    },

  }),

  computed: {
    formTitle() {
      return this.formSchema.id > 0
        ? "Edit Partial Payment"
        : "Add Partial Payment";
    },
    addUpdateBtn() {
      return this.formSchema.id > 0 ? "Update" : "Save";
    }
  },
  
  created() {    
    commonService.getAllData("get-dis-dropdown-data").then(res => {        
        this.loanNoList = res.loanNoList;
    });

    // Edit Partial pay
    if(this.formSchema.is_edit == true){ 
        this.getClientName(this.formSchema.loan_id);
      }
  },

  /*------------Datatable------------*/
  // watch: {
  //   "formSchema.is_edit": function(val) {
  //     alert(val);
  //     if(val == true){ 
  //       this.getClientName(this.formSchema.loan_id);
  //     }
  //   },
  // }, 

  methods: { 

    saveItem(){
      if (this.$refs.form.validate()) {
        this.dialog2 = true;
      }
    },
    
    validateBeforeSubmit(e) {
      if (this.$refs.form.validate()) {
        this.submitForm();
        this.dialog2 = false;
      }
    },

    submitForm() {
      var formSchema = this.formSchema;   
      formSchema.receive_date = this.changeFormateYMD(this.formSchema.receive_date); 
      formSchema.cheque_date = this.changeFormateYMD(this.formSchema.cheque_date);

      let formData = new FormData();
      formData.append("formSchema", JSON.stringify(this.formSchema));
      formData.append("debit", JSON.stringify(this.debit));
      if(formSchema.principal > 0){
        formData.append("principal", JSON.stringify(this.principal));
      }
      if(formSchema.interest > 0){
        formData.append("interest", JSON.stringify(this.interest));
      }
      if(formSchema.charge > 0){
        formData.append("charge", JSON.stringify(this.charge));
      }

      //console.log('Data',formSchema); 
      if (formSchema.id > 0) {
        commonService
          .insertFormData(formData, "partial_pay")
          .then(res => {            
            let actionData = {
              message: res.message,
              data: res.data,
              action: "edit",
              status: res.status
            };
            this.close(actionData);
            //this.getReschedule(res);
          });
      } else {
        commonService
          .insertFormData(formData, "partial_pay")
          .then(res => {
              //if(res.type == 'Reset'){
                let actionData = {
                message: res.message,
                data: res.data,
                action: "add",
                status: res.status
              };
              this.close(actionData);
            //}else{
              //this.getReschedule(res);
            //}
          });
      }
    },
    getClientName(loanId){
      let Loan = this.loanNoList.filter(function(a) {
            return a.id == loanId;
          })[0];

      // Voucher Data Set-----
       commonService
        .getAllDataById(loanId, "get-loan-data-partial-payment")
        .then(res => {
          // Currancy Rate for voucher entry

          let loanInfo = res.loanInfo;
          let disburstInfo = res.disburstInfo;

          this.formSchema.currency = loanInfo.transaction_currency;
          this.formSchema.usd_rate = disburstInfo.currency_rate;
          this.formSchema.loan_id = loanId;

          /*_________________For Debit______________*/
          let debit = this.debit;
          debit.eco_id = (disburstInfo.fund_source == "IDA") ? loanInfo.Rep_IDA_ACC_ID : loanInfo.Rep_GOB_ACC_ID;
          debit.eco_code = (disburstInfo.fund_source == "IDA") ? loanInfo.Rep_IDA_ACC_CODE : loanInfo.Rep_GOB_ACC_CODE;
          debit.account_name = (disburstInfo.fund_source == "IDA") ? loanInfo.Rep_IDA_ACC_NAME : loanInfo.Rep_GOB_ACC_NAME;
          debit.tr_debit = 0;
          debit.tr_credit = 0;
          debit.currency = loanInfo.transaction_currency;
          debit.bdt_debit = 0;
          debit.bdt_credit = 0;
          debit.usd_credit = 0;
          debit.usd_debit = 0;
          debit.src_fund = disburstInfo.fund_source;
          debit.loan_no = loanInfo.loan_no;
          /*_________________For principa ______________*/
          let principal = this.principal;
          principal.eco_id =  disburstInfo.economic_code_id;
          principal.eco_code = disburstInfo.eco_account_code;
          principal.account_name = loanInfo.loan_no;
          principal.tr_debit = 0;
          principal.tr_credit = 0;
          principal.currency = loanInfo.transaction_currency;
          principal.bdt_debit = 0;
          principal.bdt_credit = 0;
          principal.usd_credit = 0;
          principal.usd_debit = 0;
          principal.src_fund = disburstInfo.fund_source;
          principal.loan_no = loanInfo.loan_no;
          /*_________________For Credit______________*/
          let interest = this.interest;
          interest.eco_id =  disburstInfo.economic_code_id;
          interest.eco_code = disburstInfo.eco_account_code;
          interest.account_name = loanInfo.loan_no;
          interest.tr_debit = 0;
          interest.tr_credit = 0;
          interest.currency = loanInfo.transaction_currency;
          interest.bdt_debit = 0;
          interest.bdt_credit = 0;
          interest.usd_credit = 0;
          interest.usd_debit = 0;
          interest.src_fund = disburstInfo.fund_source;
          interest.loan_no = loanInfo.loan_no;
          /*_________________For Credit______________*/
          let charge = this.charge;
          charge.eco_id =  disburstInfo.economic_code_id;
          charge.eco_code = disburstInfo.eco_account_code;
          charge.account_name = loanInfo.loan_no;
          charge.tr_debit = 0;
          charge.tr_credit = 0;
          charge.currency = loanInfo.transaction_currency;
          charge.bdt_debit = 0;
          charge.bdt_credit = 0;
          charge.usd_credit = 0;
          charge.usd_debit = 0;
          charge.src_fund = disburstInfo.fund_source;
          charge.loan_no = loanInfo.loan_no;

          this.changeDataSet();
        });
        this.showVoucher = true;
    },
    //changeDataSet
    changeDataSet(){
      let debit = this.debit;
      let credit = this.credit;
      let prin_obj = this.principal;
      let inst_obj = this.interest;
      let ch_obj = this.charge;
      let principal = (this.formSchema.principal > 0) ? this.formSchema.principal : 0;
      let interest = (this.formSchema.interest > 0) ? this.formSchema.interest : 0;
      let charge = (this.formSchema.charge > 0) ? this.formSchema.charge : 0;
      this.formSchema.amount = (parseFloat(principal) + parseFloat(interest) + parseFloat(charge));
      let payAmount = this.formSchema.amount;
      let usd_rate = this.formSchema.usd_rate;
      let currency = this.formSchema.currency;
      
      var amount_rate = this.currencyChange(payAmount,currency,usd_rate);
      var pr_rate = this.currencyChange(principal,currency,usd_rate);
      var in_rate = this.currencyChange(interest,currency,usd_rate);
      var ch_rate = this.currencyChange(charge,currency,usd_rate);
      console.log('After =======',amount_rate);
      // Total Amount
      //this.formSchema.amount = (parseFloat(principal) + parseFloat(interest) + parseFloat(charge));
      debit.bdt_debit = 1200000;
      console.log('After =======',debit);
      // Debit Information
      debit.tr_debit = payAmount;
      debit.bdt_debit = amount_rate.BDT.toFixed(2);
      debit.usd_debit = amount_rate.USD.toFixed(2);
      
      // principal Information
      prin_obj.tr_credit = principal;
      prin_obj.bdt_credit = pr_rate.BDT.toFixed(2);
      prin_obj.usd_credit = pr_rate.USD.toFixed(2);
      // interest Information
      inst_obj.tr_credit = interest;
      inst_obj.bdt_credit = in_rate.BDT.toFixed(2);
      inst_obj.usd_credit = in_rate.USD.toFixed(2);
      // charge Information
      ch_obj.tr_credit = charge;
      ch_obj.bdt_credit = ch_rate.BDT.toFixed(2);
      ch_obj.usd_credit = ch_rate.USD.toFixed(2);
    },
    // Number formating methods
    numberFormate(numBer) {
      if (numBer != "-") {
        //return Number(numBer).toFixed(4);
        return Math.round(numBer);
        //return Math.round(numBer).toLocaleString()+'.00';
      } else {
        return "0.00";
      }
    },
    // Currency Change
    currencyChange(amount, currency, rate) {
      let result = { BDT: "", USD: "" };

      if (currency == "BDT") {
        result.BDT = parseFloat(amount);
        result.USD = parseFloat(amount) / parseFloat(rate);
      }
      if (currency == "USD") {
        result.BDT = parseFloat(amount) * parseFloat(rate);
        result.USD = parseFloat(amount);
      }
      return result;
    },

    setDateValue(data) {
      let index = data.index;
      this.formSchema[data.fieldName] = data.value;
    },


    createReschedule(loan_id, partialPaymentAmount, newRescheduleDate)
    {        
      this.$store.commit('UNSET_COMMON_DATA');
      var formSchema = {
        "id":0,
        "project_name_short":"",
        "loan_id":loan_id,
        "client_name":"",
        "sub_project_name":"",
      }
      
      // commonService.getAllData('get-loan-info-by-id/'+loan_id).then(res => {
      commonService.dataByMulParameters(formSchema,'get-loan-re-schedule').then(res => {
         //console.log('wwwwwwwwwwwww',loan_id);
          let data = res.data;
          
          data['loan_id'] = loan_id;
          data['available_amount'] = partialPaymentAmount;
          data['voucher_number'] = res.voucher_number   
          data['disbursement_accountInfo'] = res.disbursement_accountInfo                 
          data['old_opening_principal'] = {"id":"", "opening_principal":partialPaymentAmount}
          data['old_paid_installment_number'] = res.old_paid_installment_number
          data['new_re_schedule_date'] = newRescheduleDate;


          console.log('data==>>>', data);
          //return 0;
          this.$store.commit('SET_COMMON_DATA',data); 
          this.$router.push("/on-lending/loan-reschedule"); 
        });
      
    },

    // Get re-schedule data value  === Mute this function
    getReschedule(res){
     
      //console.log("partialPay", res);
            let instDate =  res.old_data.installment_date;
            let closing_principal = res.old_data.closing_balance;
            let lamSum_amount = [res.data];
            let reset_no = 2;

            var newRescheduleDate = res.data.receive_date;
            var lastInterestRate = res.old_data.interest_rate;

            var currentAmount = 0;
            var currentStartDate = "";
            var currentEndDate = "";
            
            var arSize = lamSum_amount.length;
            var partialPaymentData = [];

              // Partial Payment adjustment================ 
              lamSum_amount.forEach((value, index) => {
                  var currentAmount_val = (currentAmount > 0) ? Number(currentAmount) : Number(closing_principal);        
                  if(index == 0){
                    currentStartDate = instDate;
                    currentEndDate = value.receive_date;
                  }
                  else{
                    currentEndDate = value.receive_date;
                  }
                  
                  var totalDays = this.getTotalDays(currentStartDate, currentEndDate);       
                  var oneDayInterest = (((currentAmount_val * (lastInterestRate/100)) / 12 ) / 30);   
                  currentAmount = ((currentAmount_val + (oneDayInterest * totalDays) ) - value.amount);

                  console.log(currentAmount + " = (" + currentAmount_val +" + "+ oneDayInterest+ ") - "+value.amount);
                  console.log('oneDayInterest = ', oneDayInterest);
                  console.log('-----------1-------------')

                  currentStartDate = currentEndDate;

                  /* ----------Get total closing blance from last loan reset date -------------*/
                  if(arSize == index+1)
                  {
                    var totalDays = this.getTotalDays(currentStartDate, newRescheduleDate);       
                    var oneDayInterest = (((Number(currentAmount_val) * (lastInterestRate/100)) / 12 ) / 30);   
                    currentAmount = (Number(currentAmount_val) + (oneDayInterest * totalDays));

                    console.log(currentAmount + " =xxx (" + currentAmount_val +" + "+ oneDayInterest);
                    console.log('oneDayInterest = ', oneDayInterest);
                    console.log('-----------2-------------')

                    // var storeData = [
                    //   {"closing_blance" : currentAmount},
                    //   {
                    //     "data":[partialPaymentData]
                    //   }
                    // ];
                    
                  }

                  let rescheduleDate = this.changeFormateYMD(newRescheduleDate);
                  this.partialPayDataset.push({
                    'loan_id' : res.data.loan_id,
                    'closing_principal' : closing_principal,
                    'partial_amount' : value.amount,
                    'partial_date' : value.receive_date,
                    'new_closing_balance': currentAmount,
                    'partial_id' : value.id,
                    'adjust_date' :rescheduleDate,
                    'v_number':reset_no,
                    'adjust_type':'Re-schedule'
                    }
                  );
              }); 

              this.$store.commit('UNSET_KEY_VALUE');
              this.$store.commit('SET_KEY_VALUE', this.partialPayDataset); 
              console.log('currentAmount_val',this.partialPayDataset);

              //this.createReschedule(currentAmount);

              console.log('res=' + res.data.loan_id + "  currentAmount="+currentAmount);

              this.confirmDialog = true;

              //this.createReschedule(res.data.loan_id, currentAmount, adjust_date);
              //return 0;
    },

    goToShedule(){
      this.confirmDialog = false;
      var pData = this.$store.getters.GET_KEY_VALUE;
      var newRescheduleDate = this.changeFormateDMY(pData[0].adjust_date);
      this.createReschedule(pData[0].loan_id, pData[0].new_closing_balance, newRescheduleDate);
    },

    getTotalDays(startDate, endDate)
    {
        //const startDate  = '2035-09-01';
        //const endDate    = '2035-10-01';
        console.log("startDate=" + startDate + " endDate=" + endDate);

        if((startDate != "" || startDate != "0000-00-00") && (endDate != "" || endDate != "0000-00-00") )
        {
          const diffInMs   = new Date(endDate) - new Date(startDate)
          const totalDays = diffInMs / (1000 * 60 * 60 * 24) + Number(1);
          console.log('totalDays', totalDays);        
          return totalDays;
        }
        return 0;
    },

    close: function(data) { 
      if(data.status==1)
      {
        this.$refs.form.reset();
        this.formSchema.id = 0;
      }  
      this.showVoucher = false;                    
      this.$emit("emitForm", data);
    }
  }
};
</script>

<style scoped>
table.paySchedule {
  width: 100%;
  border-collapse: collapse;
}
.paySchedule th{
  border: 1px solid #CCC;
  text-align: center;
  padding: 0px;
}

.paySchedule td{
  border: 1px solid #CCC;
  line-height: 33px;  
  text-align: center;
  padding: 0px;
}

.paySchedule tr.tb-td td {
  font-weight: bold;
}
td.textCenter {
  text-align: center;
}
td.textRight {
  text-align: right;
}
td input {
  width: 100%;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/lending/partial_pay/insertForm.vue